/* eslint-disable no-console */
import _ from 'lodash';
import VError from 'verror';
import copilot from '@janus.team/janus-copilot/cjs/janus-copilot';

export const isLocal = () => (/local\.dev\.manage\.rackspace\.com/i).test(global.location.origin);
export const isTest = () => /localhost/i.test(global.location.origin);
export const baseUrl = () => (isLocal() ? 'https://dev.manage.rackspace.com' : global.location.origin);
export const projectsPollingInterval = () => +(process.env.REACT_APP_PROJECTS_POLLING_INTERVAL_IN_SECONDS || 30);
export const accessGrantsPollingInterval = () => +(process.env.REACT_APP_ACCESS_GRANTS_POLLING_INTERVAL_IN_SECONDS || 30);
// This regex matches /racker/customers/DDIStringAndNumbers/ResourceStringAndNumbers
const domainFromURLRegex = /(.*\/racker\/[a-z:0-9\-_]+\/?)([a-z:0-9]+|$)(.*|$)/i;
export const copilotApplicationContainerProps = (rest = {}) => ({
  onCatalogError: _.noop,
  onMissingCatalog: _.noop,
  onInvalidCatalog: _.noop,
  cloud: 'gcp',
  catalogOverrides: (catalog) => copilot.mergeUtilityNavigationLinksByRel(catalog, { gcp: { to: '/racker', active: true } }),
  credentials: isLocal() ? 'include' : 'same-origin',
  baseUrl: baseUrl(),
  domainFromURLRegex,
  active: 'racker-gcp',
  sha: process.env.REACT_APP_SHA,
  useJanusLogin: true,
  janusLoginServerCsrfCookieName: process.env.REACT_APP_LOGIN_SERVER_CSRF_TOKEN_NAME || '__janus_login_csurf_dev_subdomain__',
  ...rest,
});
const globalAudience = () => (global.isRacker ? 'racker' : 'customer');
const locationAudience = () => ((/\/racker($|\/)/gi).test(`${global.location.pathname}`) ? 'racker' : 'customer');

export const audience = () => (_.isBoolean(global.isRacker) ? globalAudience() : locationAudience());
export const isRacker = () => (audience() === 'racker');
// shorthand notation from janus-login to minimize url clutter for proxyied api calls
export const proxyAudience = (currentAudience) => currentAudience || (isRacker() ? 'r' : 'c');

const isRetryable = (error) => ![400, 401, 403, 404].includes(VError.info(error).status);

const FIVE_MINUTES = 300000;

export const queryCache = (extras) => ({
  defaultOptions: {
    queries: {
      refetchIntervalInBackground: false,
      refetchInterval: false,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => !isTest() && failureCount < 3 && isRetryable(error),
      staleTime: isTest() ? 0 : Infinity,
      cacheTime: isTest() ? 0 : FIVE_MINUTES,
      ...extras,
    },
  },
});

// See components/feature-flags
export const FEATURE_FLAG_ENV_PREFIX = 'REACT_APP_FFLAG_';
export const getDefaultFeatureFlags = () => ({
  allowOrgClaim: false,
  forceOnboarding: false,
  useSubscriptions: false,
});

export const gcpProjectsFilter = (rackspaceAccountNumber) => _.get({
  1192365: 'NOT id:"sys-*"',
}, rackspaceAccountNumber);
